import React from 'react';

const Footer = () => {
  return (
    <div className="w-full h-18 bg-secondary px-8 md:px-16 lg:px-36 py-8">
      <span>© 2022 Abdullahi Muritala </span>
    </div>
  );
};

export default Footer;
